export default function sortByProperty(property, ascending = true) {
  return (a, b) => {
    let result = 0
    if (typeof a[property] === 'string') {
      result = a[property].localeCompare(b[property])
    } else if (typeof a[property] === 'number') {
      result = a[property] - b[property]
    }
    return ascending ? result : -1 * result
  }
}
